export enum WorkflowType {
  Ingest = "Ingest",
  PurgeMediaFile = "PurgeMediaFile",
  BypassRejection = "BypassRejection",
  DeliveryFaspexSend = "DeliveryFaspexSend",
  DeliveryTranscodeGeneric = "DeliveryTranscodeGeneric",
  DeliveryTranscodeByProfile = "DeliveryTranscodeByProfile",
  DeliveryTranscodeAsInput = "DeliveryTranscodeAsInput",
  IngestSubtitle = "IngestSubtitle",
  ProxyTag = "ProxyTag",
  DeliveryAntipiracyInaSignature = "DeliveryAntipiracyInaSignature",
  DeliveryAntipiracyYoutube = "DeliveryAntipiracyYoutube",
  DeliveryTranscodeByProfileAndPrintToTape = "DeliveryTranscodeByProfileAndPrintToTape",
  QualityCheck = "QualityCheck",
  Qualify = "Qualify",
  ProxyMaker = "ProxyMaker",
  DeliveryTranscodeBundleByProfile = "DeliveryTranscodeBundleByProfile",
  Generic = "Generic",
}
